import React from 'react';
import {
  ArrayInput,
  AutocompleteInput,
  BooleanInput,
  DateTimeInput,
  Edit as RaEdit,
  FormTab,
  NumberInput,
  required,
  SimpleFormIterator,
  TabbedForm,
  TextInput,
} from 'react-admin';
import MarkdownInput from 'ra-input-markdown';

import defaultTranslations from '@src/assets/defaultTranslations';
import Locales from '@src/assets/locales';

const Edit: React.FC = (props) => (
  <RaEdit {...props}>
    <TabbedForm redirect="show">
      <FormTab label="Details" path="">
        <TextInput source="code" fullWidth validate={[required()]} />
        <NumberInput step={1} source="amount" />
        <NumberInput step={1} source="percent" />
        <NumberInput step={1} source="maximum" validate={[required()]} />
        <NumberInput step={1} source="total" validate={[required()]} />
        <DateTimeInput source="expire_at" validate={[required()]} />
        <BooleanInput source="active" defaultValue={true} />
      </FormTab>
      <FormTab label="description" path="description">
        <ArrayInput
          source="description_translations"
          label=""
          validate={[required()]}
          defaultValue={defaultTranslations}
        >
          <SimpleFormIterator>
            <AutocompleteInput
              source="locale"
              choices={Locales}
              validate={[required()]}
            />
            <MarkdownInput source="content" validate={[required()]} />
          </SimpleFormIterator>
        </ArrayInput>
      </FormTab>
    </TabbedForm>
  </RaEdit>
);

export default Edit;
